import React, { useEffect, useState, useReducer, useRef } from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  List,
  Select,
  TextField,
  MenuItem,
  SwipeableDrawer,
  Toolbar,
  AppBar,
  InputAdornment,
  Dialog,
  DialogTitle,
  Button,
  Typography,
  DialogContent,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ClickAwayListener,
  Tooltip,
} from "@material-ui/core";

import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import InfoIcon from "@material-ui/icons/Info";
import CloudOffIcon from "@material-ui/icons/CloudOff";
import CloudQueueIcon from "@material-ui/icons/CloudQueue";
import SwapVertIcon from "@material-ui/icons/SwapVert";
import { Popover } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import CloseIcon from "@material-ui/icons/Close";
import Chip from "@material-ui/core/Chip";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";
import useStyles from "../../themes/style.js";
import { yupResolver } from "@hookform/resolvers/yup";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardMedia";
import { Menu as MenuIcon } from "@material-ui/icons";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import SettingsIcon from "@material-ui/icons/Settings";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import axios from "axios";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import Notification from "../../components/Notification";
import {
  toggleSidebar,
  useLayoutDispatch,
  useLayoutState,
} from "../../context/LayoutContext";
import Fab from "@mui/material/Fab";
import { signOut, useUserDispatch } from "../../context/UserContext";
import { useHistory } from "react-router-dom";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import DeleteIcon from "@material-ui/icons/Delete";
import FileCopyIcon from "@material-ui/icons/FileCopy";

import PermContactCalendarIcon from "@material-ui/icons/PermContactCalendar";
import PublishIcon from "@material-ui/icons/Publish";
import sample_candidates from "../../images/files/sample_candidates.xlsx";
import "react-toastify/dist/ReactToastify.css";
import RecCoinsWallet from "./RecCoinsWallet.js";
import VendorCoinsWallet from "./VendorCoinsWallet.js";
import { useEmployeeDetails } from "../../context/EmployeeDataContext.js";
import { customTheme } from "../Layout/muiTheme.js";

export default function EmployeeHeader(props) {
  var classes = useStyles();
  const token = localStorage.getItem("token");
  const [reducerValue, forceUpdate] = useReducer((x) => x + 1, 0);
  var userDispatch = useUserDispatch();
  var layoutDispatch = useLayoutDispatch();
  var layoutState = useLayoutState();
  var [notificationsPosition] = useState(2);
  var [errorToastId, setErrorToastId] = useState(null);
  var [profileMenu, setProfileMenu] = useState(null);
  var [view, setView] = useState("");
  const history = useHistory();

  var [backupView, setBackupView] = useState({
    view: "",
    link: "",
  });

  const { profileMenuName } = useEmployeeDetails();

  // console.log(profileMenuName);

  async function copyTextToClipboard(text) {
    if ("clipboard" in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand("copy", true, text);
    }
  }

  const handleFromMonthChange = (e) => {
    const selectedFromMonth = e.target.value;
    const selectedFromMonthIndex = monthDropdown.findIndex(
      (month) => month.id === selectedFromMonth,
    );

    if (selectedFromMonthIndex !== -1) {
      const endMonthIndex = (selectedFromMonthIndex + 11) % 12;
      const endMonth = monthDropdown[endMonthIndex].id;

      setMonthValue({
        fromMonth: selectedFromMonth,
        toMonth: endMonth,
      });
    } else {
      console.error("Invalid fromMonth selected:", selectedFromMonth);
    }
  };

  const handleProfileMenuOpen = (e) => {
    setProfileMenu(e.currentTarget);
  };

  const toRef = useRef(null);
  const fromRef = useRef(null);

  const monthDropdown = [
    {
      id: "1",
      Month: "JANUARY",
    },
    {
      id: "2",
      Month: "FEBRUARY",
    },
    {
      id: "3",
      Month: "MARCH",
    },
    {
      id: "4",
      Month: "APRIL",
    },

    {
      id: "5",
      Month: "MAY",
    },
    {
      id: "6",
      Month: "JUNE",
    },
    {
      id: "7",
      Month: "JULY",
    },
    {
      id: "8",
      Month: "AUGUST",
    },

    {
      id: "9",
      Month: "SEPTEMBER",
    },

    {
      id: "10",
      Month: "OCTOBER",
    },

    {
      id: "11",
      Month: "NOVEMBER",
    },

    {
      id: "12",
      Month: "DECEMBER",
    },
  ];

  const [loader, setLoader] = useState(false);

  const [state, setState] = useState({
    right: false,
  });

  const [popperOpen, setPopperOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const getFinancialYearLabel = (fromMonth, toMonth) => {
    const fromMonthObject = monthDropdown.find(
      (month) => month.id === fromMonth,
    );
    const toMonthObject = monthDropdown.find((month) => month.id === toMonth);

    if (fromMonthObject && toMonthObject) {
      return `${fromMonthObject.Month}-${toMonthObject.Month}`;
    } else {
      return "Invalid month selection";
    }
  };

  const canBeOpen = popperOpen && Boolean(anchorEl);
  const poperId = canBeOpen ? "spring-popper" : undefined;

  const toggleDrawer = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
  };

  const positions = [toast.POSITION.TOP_RIGHT];
  function sendNotification(componentProps, options) {
    return toast(
      <Notification
        {...componentProps}
        className={classes.notificationComponent}
      />,
      options,
    );
  }
  function handleNotificationCall(notificationType, message) {
    var componentProps;

    if (errorToastId && notificationType === "error") return;

    switch (notificationType) {
      case "info":
        componentProps = {
          type: "feedback",
          message: message,
          variant: "contained",
          color: "primary",
        };
        break;
      case "error":
        componentProps = {
          type: "message",
          message: message,
          variant: "contained",
          color: "secondary",
        };
        break;
      default:
        componentProps = {
          type: "shipped",
          message: message,
          variant: "contained",
          color: "success",
        };
    }

    var toastId = sendNotification(componentProps, {
      type: notificationType,
      position: positions[notificationsPosition],
      progressClassName: classes.progress,
      onClose: notificationType === "error" && (() => setErrorToastId(null)),
      className: classes.notification,
    });

    if (notificationType === "error") setErrorToastId(toastId);
  }

  const [Month, setMonthValue] = useState({
    fromMonth: "4",
    toMonth: "3",
  });

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required("Email is required")
      .email("Email must be a Valid Email Address"),
    firstName: Yup.string().max(255).required("First Name is required"),
    lastName: Yup.string().max(255).required("Last Name is required"),
    mobile: Yup.string()
      .required("Mobile is required")
      .min(10, "Must be exactly 10 digits")
      .max(10, "Must be exactly 10 digits"),
    companyName: Yup.string().max(255).required("Company Name is required"),
  });

  const changeSchema = Yup.object().shape({
    old: Yup.string()
      .required("Old Password is required")
      .min(8, "Old Password must be at least 8 characters"),
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters"),
    confirm: Yup.string()
      .required("Confirm Password is required")
      .min(8, "Confirm Password must be at least 8 characters"),
  });

  const {
    register: changePassword,
    formState: { errors: changeErrors, isSubmitting: changeIsSubmitting },
    handleSubmit: changeSubmit,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(changeSchema),
  });

  const { handleSubmit: uploadSubmit } = useForm({
    mode: "onBlur",
  });

  const [values, setValues] = React.useState({
    showOldPassword: false,
    showPassword: false,
    showConfirmPassword: false,
  });

  const handleClickOldPassword = () => {
    setValues({ ...values, showOldPassword: !values.showOldPassword });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleClickConfirmPassword = () => {
    setValues({ ...values, showConfirmPassword: !values.confirm });
  };

  function handleChange(event) {
    // setProfileImage(URL.createObjectURL(event.target.files[0]));

    var FormData = require("form-data");
    var data = new FormData();
    data.append("image", event.target.files[0]);

    setLoader(true);
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}admin/setLogo`,
      data: data,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "",
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setLoader(false);
        handleNotificationCall("success", response.data.message);
        // setProfileImage(response.data.image);
      } else {
        setLoader(false);
        handleNotificationCall("error", response.data.message);
      }
    });
  }

  function handleCompanySettings(values) {
    const dataToSend = {
      fromMonth: Month.fromMonth,
      toMonth: Month.toMonth,
    };

    return new Promise((resolve) => {
      setLoader(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}admin/editMyCompanySettings`,
        data: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: "",
        },
      })
        .then(function (response) {
          if (response.data.status === true) {
            handleNotificationCall("success", response.data.message);
            forceUpdate();
            setState({ ...state, right: false });
          } else {
            handleNotificationCall("error", response.data.message);
          }
          setLoader(false);
          resolve();
        })
        .catch(function (error) {
          console.error(error);
          handleNotificationCall(
            "error",
            "An error occurred while updating settings.",
          );
          setLoader(false);
        });
    });
  }

  function handleArchiveDownload(view) {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}admin/archiveDownload`,
      data: {},
      headers: {
        "Content-Type": "application/json",
        Authorization: "",
      },
    })
      .then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          setBackupView({
            ...backupView,
            view: view,
            link: response.data.link,
          });
        } else {
          setLoader(false);

          handleNotificationCall("error", response.data.message);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  async function handleChangePassword(values) {
    if (values.password !== values.confirm) {
      handleNotificationCall("error", "Password is mismatch");
      return;
    }
    setLoader(true);
    try {
      var url = `${process.env.REACT_APP_SERVER}auth/changeMyPassword`;

      const response = await axios({
        method: "post",
        url: url,
        data: {
          newPassword: values.password,
          oldPassword: values.old,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "",
        },
      });

      if (response.data.status === true) {
        handleNotificationCall("success", response.data.message);
        forceUpdate();
        setState({ ...state, right: false });
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  }

  async function handleLogoutAttendance() {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}auth/logoutUser`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );
      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    const changeWallet = () => {
      forceUpdate();
    };

    window.addEventListener("storage", changeWallet);
    return () => {
      window.removeEventListener("storage", changeWallet);
    };
  }, []);

  function getEmpName(user) {
    let empName;
    if (user.employee) {
      empName = user.employee.firstName + " " + user.employee.lastName;
    }

    if (user.recruiter) {
      empName = user.recruiter.firstName + " " + user.recruiter.lastName;
    }
    return empName;
  }

  const list = (anchor) => (
    <Box sx={{ width: "100%" }} role="presentation">
      <List>
        {view === "Settings" ? (
          <>
            <Card className={classes.root}>
              <CardHeader>
                <Grid
                  container
                  direction="row"
                  spacing={1}
                  className={classes.drawerHeader}
                >
                  <Grid item xs={10} md={6}>
                    <Typography variant="subtitle1"> Settings </Typography>
                  </Grid>

                  <Grid item xs={2} lg={6} className={classes.drawerClose}>
                    <CloseIcon
                      className={classes.closeBtn}
                      size="14px"
                      onClick={toggleDrawer(anchor, false)}
                    />
                  </Grid>
                </Grid>
              </CardHeader>

              <form onSubmit={uploadSubmit(handleCompanySettings)}>
                <CardContent className={classes.root}>
                  <Grid container direction="row" spacing={2}>
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        className={classes.ProfileLogoContainer}
                      >
                        <Avatar alt="Profile" src={""} />
                      </Box>
                    </Grid>
                  </Grid>

                  <Grid container direction="row" spacing={2}>
                    <Grid item xs={12} lg={4}></Grid>

                    <Grid item xs={12} lg={4}>
                      <FormControl>
                        <div className={classes.root + " " + classes.center}>
                          <input
                            accept="image/*"
                            className={classes.input}
                            id="icon-button-file"
                            type="file"
                            style={{ display: "none" }}
                            onChange={handleChange}
                          />
                          <label htmlFor="icon-button-file">
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.button}
                              startIcon={<PhotoCamera />}
                              aria-label="upload picture"
                              component="span"
                            >
                              Upload Logo
                            </Button>
                          </label>
                        </div>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={4}></Grid>
                    <Grid item xs={12}>
                      <InputLabel shrink htmlFor="fromMonth">
                        Financial Year
                      </InputLabel>

                      <FormControl className={classes.margin}>
                        <div className={classes.space}>
                          <Select
                            labelId="fromMonth"
                            name="fromMonth"
                            defaultValue={Month.fromMonth}
                            classes={{
                              root: classes.customSelectField,
                              icon: classes.customSelectIcon,
                            }}
                            onChange={handleFromMonthChange}
                            inputRef={fromRef}
                            disableUnderline
                          >
                            <MenuItem value="">Select option</MenuItem>
                            {monthDropdown.map((item, index) => {
                              return [
                                <MenuItem value={item.id}>
                                  {item.Month}
                                </MenuItem>,
                              ];
                            })}
                          </Select>

                          <Select
                            labelId="toMonth"
                            name="toMonth"
                            style={{ display: "none" }}
                            defaultValue={Month.toMonth}
                            onChange={(e) => {
                              setMonthValue({
                                ...Month,
                                toMonth: e.target.value,
                              });
                            }}
                            classes={{
                              root: classes.customSelectField,
                              icon: classes.customSelectIcon,
                            }}
                            inputRef={toRef}
                            disableUnderline
                          >
                            <MenuItem value="">Select option</MenuItem>
                            {monthDropdown.map((item, index) => {
                              return [
                                <MenuItem value={item.id}>
                                  {item.Month}
                                </MenuItem>,
                              ];
                            })}
                          </Select>
                        </div>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      {getFinancialYearLabel(Month.fromMonth, Month.toMonth)}
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions>
                  <Grid
                    container
                    direction="row"
                    spacing={2}
                    className={classes.drawerFooter}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      type="submit"
                      disabled={loader}
                    >
                      Update
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      color="secondary"
                      onClick={toggleDrawer(anchor, false)}
                    >
                      Close
                    </Button>
                  </Grid>
                </CardActions>
              </form>
            </Card>
          </>
        ) : view === "Change" ? (
          <>
            <Card className={classes.root}>
              <CardHeader>
                <Grid
                  container
                  direction="row"
                  spacing={1}
                  className={classes.drawerHeader}
                >
                  <Grid item xs={10} md={6}>
                    <Typography variant="subtitle1">Change Password</Typography>
                  </Grid>

                  <Grid item xs={2} lg={6} className={classes.drawerClose}>
                    <CloseIcon
                      className={classes.closeBtn}
                      size="14px"
                      onClick={toggleDrawer(anchor, false)}
                    />
                  </Grid>
                </Grid>
              </CardHeader>

              <form onSubmit={changeSubmit(handleChangePassword)}>
                <CardContent className={classes.root}>
                  <Grid container direction="row" spacing={2}>
                    <Grid item xs={12}>
                      <InputLabel shrink htmlFor="old">
                        Old Password
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          classes={{ root: classes.customTextField }}
                          type={values.showOldPassword ? "text" : "password"}
                          placeholder="Enter Password"
                          InputProps={{
                            disableUnderline: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickOldPassword}
                                >
                                  {values.showOldPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          {...changePassword("old")}
                          error={changeErrors.old ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {changeErrors.old?.message}
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} lg={6}>
                      <InputLabel shrink htmlFor="password">
                        Password
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          classes={{ root: classes.customTextField }}
                          type={values.showPassword ? "text" : "password"}
                          placeholder="Enter Password"
                          InputProps={{
                            disableUnderline: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                >
                                  {values.showPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          {...changePassword("password")}
                          error={changeErrors.password ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {changeErrors.password?.message}
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} lg={6}>
                      <InputLabel shrink htmlFor="confirm">
                        Confirm Password
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          classes={{ root: classes.customTextField }}
                          type={
                            values.showConfirmPassword ? "text" : "password"
                          }
                          placeholder="Enter Confirm Password"
                          InputProps={{
                            disableUnderline: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickConfirmPassword}
                                >
                                  {values.showConfirmPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          {...changePassword("confirm")}
                          error={changeErrors.confirm ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {changeErrors.confirm?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions>
                  <Grid
                    container
                    direction="row"
                    spacing={2}
                    className={classes.drawerFooter}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      type="submit"
                      disabled={changeIsSubmitting}
                    >
                      Update
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      color="secondary"
                      onClick={toggleDrawer(anchor, false)}
                    >
                      Close
                    </Button>
                  </Grid>
                </CardActions>
              </form>
            </Card>
          </>
        ) : (
          <></>
        )}
      </List>
    </Box>
  );

  return (
    <>
      <AppBar
        position="fixed"
        className={
          layoutState.isSidebarOpened ? classes.appBar1 : classes.appBar
        }
      >
        <Toolbar className={classes.toolbar}>
          <IconButton
            color="inherit"
            onClick={() => toggleSidebar(layoutDispatch)}
            className={classNames(
              classes.headerMenuButtonSandwich,
              classes.headerMenuButtonCollapse,
            )}
          >
            {layoutState.isSidebarOpened ? (
              <MenuIcon
                classes={{
                  root: classNames(
                    classes.headerIcon,
                    classes.headerIconCollapse,
                  ),
                }}
              />
            ) : (
              <MenuIcon
                classes={{
                  root: classNames(
                    classes.headerIcon,
                    classes.headerIconCollapse,
                  ),
                }}
              />
            )}
          </IconButton>

          <div
            className={
              layoutState.isSidebarOpened
                ? classes.headerTopOpen
                : classes.headerTop
            }
          >
            <div
              className={
                layoutState.isSidebarOpened
                  ? classes.headerWidth
                  : classes.headerWidth1
              }
            >
              <Typography variant="h5" className={classes.title}>
                <span className="refo-font">refo</span>
              </Typography>
            </div>

            <div className={classes.grow}>
              <ClickAwayListener onClickAway={(e) => setProfileMenu(false)}>
                <div>
                  <IconButton
                    aria-haspopup="true"
                    color="inherit"
                    className={classes.headerMenuButton}
                    aria-controls="profile-menu"
                    onClick={(e) => handleProfileMenuOpen(e)}
                  >
                    <Avatar
                      alt="Profile"
                      src={""}
                      className={classes.profileButton}
                    />
                  </IconButton>

                  {profileMenu ? (
                    <div className={classes.dropdown}>
                      <ListItem className={classes.profileHeader}>
                        <ListItemAvatar>
                          <Avatar
                            alt={"A"}
                            sizes="medium"
                            src={""}
                            className={classes.chipAvatar}
                          />
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <Box
                              style={{
                                color: customTheme.palette.common.white,
                              }}
                            >
                              <Typography color="inherit">
                                {getEmpName(profileMenuName)}
                              </Typography>
                              <Typography color="inherit">
                                {profileMenuName.roleName ===
                                "CLIENTCOORDINATOR"
                                  ? "HIRINGMANAGER"
                                  : profileMenuName.roleName}
                              </Typography>
                              <Typography color="inherit">
                                {profileMenuName.email}
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItem>

                      <ListItem
                        className={classes.profileMenuIcon}
                        onClick={(e) => {
                          setView("Change");
                          setState({ ...state, right: true });
                        }}
                      >
                        <VpnKeyIcon /> Change Password
                      </ListItem>

                      <ListItem
                        className={classes.profileMenuIcon}
                        onClick={() => {
                          handleLogoutAttendance();
                          signOut(userDispatch, props.history);
                        }}
                      >
                        <ExitToAppIcon /> Logout
                      </ListItem>
                    </div>
                  ) : null}
                </div>
              </ClickAwayListener>
            </div>
          </div>
        </Toolbar>

        <SwipeableDrawer
          anchor="right"
          open={state["right"]}
          onClose={toggleDrawer("right", false)}
          onOpen={toggleDrawer("right", true)}
          classes={{
            paper:
              view === "Client" || view === "Candidate"
                ? classes.clientDrawer
                : classes.drawer,
          }}
        >
          {view === "Settings" || view === "Profile" || view === "Change"
            ? list("right")
            : ""}
        </SwipeableDrawer>
      </AppBar>

      <Popover
        aria-describedby={poperId}
        open={popperOpen}
        onClose={() => {
          setPopperOpen(false);
        }}
        anchorEl={anchorEl}
        sx={{ top: "80%" }}
        anchorPosition={{ top: 225, right: 10, left: 0 }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Box>
          <Card sx={{ maxWidth: 250 }}>
            <CardHeader>
              <Box className={classes.chipMessageBox}>
                <Chip
                  variant="outlined"
                  className={classes.chipMessage}
                  label={
                    <>
                      <Typography>
                        <span className={classes.colorWhite}>Naveen Vicky</span>
                      </Typography>
                    </>
                  }
                  avatar={
                    <Avatar
                      alt="Naveen"
                      sizes="medium"
                      src={""}
                      className={classes.chipMessageAvatar}
                    />
                  }
                ></Chip>
              </Box>
            </CardHeader>
            <CardContent>
              <Typography variant="body2" className={classes.chipMessageText}>
                REFO is available in mobile browser. use after candidate upload
                is super easy experience!
              </Typography>
              <Typography variant="body2" className={classes.chipMessageText}>
                Do every other task using your mobile browser.
              </Typography>
              <div className={classes.flexCenter}>
                <Button
                  endIcon={<WhatsAppIcon />}
                  variant="contained"
                  size="small"
                  className={classes.whatsappSend}
                  onClick={(e) => {
                    window.open(
                      "https://api.whatsapp.com/send?phone=+91" +
                        localStorage.getItem("mobile") +
                        `&text=REFO is available in mobile browser so after candidate upload is super easy experience! \n Do every other task using your mobile browser. - ${process.env.REACT_APP_DOMAIN}`,
                    );
                  }}
                >
                  Send to
                </Button>
              </div>
            </CardContent>
          </Card>
        </Box>
      </Popover>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
